import { render } from "./UserStatement.vue?vue&type=template&id=4e566dc2&scoped=true"
import script from "./UserStatement.vue?vue&type=script&lang=js"
export * from "./UserStatement.vue?vue&type=script&lang=js"

import "./UserStatement.vue?vue&type=style&index=0&id=4e566dc2&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e566dc2"]])

export default __exports__